import axios from 'axios';
import type { 
  Course, 
  CreateCourseRequest, 
  UpdateCourseRequest,
  ImportCourseData,
  SyncCoursesRequest,
  ApiResponse,
  PaginationParams 
} from '../../../shared/types';

const API_BASE_URL = '/api/v1/courses';

export interface CourseWithNganh extends Course {
  TenNganh?: string;
}

export interface CourseListResponse {
  success: boolean;
  data: CourseWithNganh[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  message: string;
}

export interface CourseResponse {
  success: boolean;
  data: CourseWithNganh;
  message: string;
}

export interface ImportCourseResponse {
  success: boolean;
  data: {
    inserted: Course[];
    errors: Array<{
      item: ImportCourseData;
      error: string;
    }>;
  };
  message: string;
}

export interface SyncCourseResponse {
  success: boolean;
  data: {
    added: number;
    updated: number;
  };
  message: string;
}

export interface CourseFilterParams extends PaginationParams {
  nganhHocId?: string;
}

class CourseService {
  // Lấy danh sách khóa học
  async getCourses(params?: CourseFilterParams): Promise<CourseListResponse> {
    const response = await axios.get<CourseListResponse>(API_BASE_URL, { params });
    return response.data;
  }

  // Lấy thông tin chi tiết một khóa học
  async getCourseById(id: string): Promise<CourseResponse> {
    const response = await axios.get<CourseResponse>(`${API_BASE_URL}/${id}`);
    return response.data;
  }

  // Tạo khóa học mới
  async createCourse(data: CreateCourseRequest): Promise<CourseResponse> {
    const response = await axios.post<CourseResponse>(API_BASE_URL, data);
    return response.data;
  }

  // Cập nhật thông tin khóa học
  async updateCourse(id: string, data: UpdateCourseRequest): Promise<CourseResponse> {
    const response = await axios.put<CourseResponse>(`${API_BASE_URL}/${id}`, data);
    return response.data;
  }

  // Xóa khóa học
  async deleteCourse(id: string): Promise<ApiResponse> {
    const response = await axios.delete<ApiResponse>(`${API_BASE_URL}/${id}`);
    return response.data;
  }

  // Import khóa học từ Excel
  async importCourses(items: ImportCourseData[]): Promise<ImportCourseResponse> {
    const response = await axios.post<ImportCourseResponse>(`${API_BASE_URL}/import`, { items });
    return response.data;
  }

  // Đồng bộ khóa học từ CSDL phụ
  async syncCourses(data: SyncCoursesRequest): Promise<SyncCourseResponse> {
    const response = await axios.post<SyncCourseResponse>(`${API_BASE_URL}/sync`, data);
    return response.data;
  }

  // Xuất template Excel
  async downloadTemplate(): Promise<Blob> {
    const response = await axios.get(`${API_BASE_URL}/template`, {
      responseType: 'blob'
    });
    return response.data;
  }
}

export default new CourseService(); 